export const CANONICAL_PROCESS_SCHEMA_VERSION = '1.0';

export const CANONICAL_PLATFORMS = Object.freeze({
  JIRA: 'jira',
  SERVICENOW: 'servicenow',
  MANUAL: 'manual',
  UNKNOWN: 'unknown',
});

export function createCanonicalDataset({
  platform = CANONICAL_PLATFORMS.UNKNOWN,
  model = {},
  cases = [],
  events = [],
  caseAttributes = [],
  eventAttributes = [],
  metadata = {},
} = {}) {
  return {
    schemaVersion: CANONICAL_PROCESS_SCHEMA_VERSION,
    source: {
      platform,
      extractedAt: metadata.extractedAt || new Date().toISOString(),
      ...metadata.source,
    },
    model: {
      id: model.id == null ? '' : String(model.id),
      name: model.name == null ? '' : String(model.name),
      processType: model.processType == null ? '' : String(model.processType),
      ...model,
    },
    attributeDefinitions: {
      case: [...caseAttributes],
      event: [...eventAttributes],
    },
    cases: [...cases],
    events: [...events],
    metadata: { ...metadata, source: undefined },
  };
}

export function validateCanonicalDataset(dataset) {
  const errors = [];
  if (!dataset || typeof dataset !== 'object') return { valid: false, errors: ['Dataset must be an object'] };
  if (dataset.schemaVersion !== CANONICAL_PROCESS_SCHEMA_VERSION) errors.push(`Unsupported schemaVersion: ${dataset.schemaVersion || '(missing)'}`);
  if (!dataset.source?.platform) errors.push('source.platform is required');
  if (!Array.isArray(dataset.cases)) errors.push('cases must be an array');
  if (!Array.isArray(dataset.events)) errors.push('events must be an array');

  const caseIds = new Set();
  for (const c of dataset.cases || []) {
    if (!c?.id) errors.push('Every case requires id');
    else if (caseIds.has(String(c.id))) errors.push(`Duplicate case id: ${c.id}`);
    else caseIds.add(String(c.id));
  }

  for (const e of dataset.events || []) {
    if (!e?.id) errors.push('Every event requires id');
    if (!e?.caseId) errors.push(`Event ${e?.id || '(unknown)'} requires caseId`);
    else if (!caseIds.has(String(e.caseId))) errors.push(`Event ${e?.id || '(unknown)'} references missing case ${e.caseId}`);
    if (!e?.activity) errors.push(`Event ${e?.id || '(unknown)'} requires activity`);
    if (!e?.timestamp) errors.push(`Event ${e?.id || '(unknown)'} requires timestamp`);
  }

  return { valid: errors.length === 0, errors };
}
